// The add-in opens the portal signed in: `/auth/link#code=…&next=/billing`. The code is single use and lives two
// minutes (sculpt-api `POST /token/portal-link`); this portal trades it for its own session (`POST /token/exchange`).
// It rides the fragment so it never reaches a server log.
import { safeReturnTo } from './callback';

export interface LinkParams {
  code: string | null;
  next: string;
}

export function parseLinkHash(hash: string): LinkParams {
  const params = new URLSearchParams(hash.startsWith('#') ? hash.slice(1) : hash);
  return { code: params.get('code') || null, next: safeReturnTo(params.get('next')) };
}
